import type { PoiCategory } from '@ooh/contracts';

/**
 * Returns the translated display label for a POI category.
 * Key format: pois.categories.{osm_key}-{osm_value}
 * Falls back to "{osm_key}/{osm_value}" if no translation exists.
 *
 * Accepts `t` as `any` because the key is computed dynamically and
 * i18next's strict TS types only accept statically-known keys.
 */
export function getCategoryLabel(
  cat: Pick<PoiCategory, 'osm_key' | 'osm_value'>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: any,
): string {
  const key = `pois.categories.${cat.osm_key}-${cat.osm_value}`;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const translated = (t(key) as string | undefined) ?? key;
  // i18next returns the key itself when no translation found
  return translated === key ? `${cat.osm_key}/${cat.osm_value}` : translated;
}
